// extracted by mini-css-extract-plugin
export var actionButton = "_e2-0";
export var attachmentLine = "_e2-1";
export var fileInput = "_e2-2";
export var fileUploadWrapper = "_e2-4";
export var footer = "_e2-3";
export var modalContent = "_e2-5";
export var paperclip = "_e2-6";
export var quillEditor = "_e2-7";